import React from "react";
import type { InputsRegistrationDataProps } from "../../organisms";
import { HeroDataInfo, InputsRegistrationData, ScreenResponsive } from "../../organisms";
import {
	Box,
	Callout,
	Grid,
	GridItem,
	IconInformationUserRegular,
	Stack,
	skinVars,
	useScreenSize,
} from "@telefonica/mistica";
import { Button } from "../../atoms";
import { strings } from "../../../localization";
import { observer } from "mobx-react-lite";
import { isEmailValid, isNameValid } from "../../../utils/validators";

interface IProps {
	inputsRegistrationDataProps: InputsRegistrationDataProps;
	textButton?: string;
	screenTitle?: string;
	title: string;
	description: string;
	calloutDescription: string;
	isLoading?: boolean;
	icon: JSX.Element;
	onBack(): void;
	onContinue(): Promise<void> | void;
}

export const RegistrationData: React.FC<IProps> = observer((props) => {
	const { anticipation } = strings.pages.navigation;
	const {
		textButton,
		screenTitle = anticipation,
		title,
		description,
		calloutDescription,
		icon,
		inputsRegistrationDataProps,
		onBack,
		onContinue,
		isLoading = false,
	} = props;
	const { buttonPrimary } = strings.components.buttons;
	const { isDesktopOrBigger } = useScreenSize();
	const { email, name, phoneNumber } = inputsRegistrationDataProps;
	const disabled = !isEmailValid(email) || !isNameValid(name) || !phoneNumber;

	return (
		<ScreenResponsive navigationTitle={screenTitle} onBack={onBack}>
			<Box paddingBottom={isDesktopOrBigger ? 24 : 0}>
				<Box paddingBottom={isDesktopOrBigger ? 80 : 32} paddingTop={isDesktopOrBigger ? 40 : 32}>
					<Stack space={32}>
						<Grid columns={isDesktopOrBigger ? 4 : 1} justifyContent={"center"}>
							<GridItem columnStart={2} span={isDesktopOrBigger ? 2 : 1}>
								<Box width={isDesktopOrBigger ? 600 : "100%"}>
									<Box paddingBottom={isDesktopOrBigger ? 40 : 32}>
										<HeroDataInfo icon={icon} title={title} description={description} />
									</Box>
									<Grid columns={{ maxSize: 392 }} justifyContent={"center"}>
										<Stack space={16}>
											<InputsRegistrationData {...inputsRegistrationDataProps} />
											<Box>
												<Callout
													icon={<IconInformationUserRegular color={skinVars.colors.brand} />}
													description={calloutDescription}
												/>
											</Box>
										</Stack>
										<Box paddingTop={isDesktopOrBigger ? 40 : 32}>
											<Button
												isDisabled={disabled || isLoading}
												textButton={textButton || buttonPrimary}
												isLoading={isLoading}
												onAction={onContinue}
												testID="button-user"
											/>
										</Box>
									</Grid>
								</Box>
							</GridItem>
						</Grid>
					</Stack>
				</Box>
			</Box>
		</ScreenResponsive>
	);
});
